import { render } from "./bulletin-message.vue?vue&type=template&id=11eec77c"
import script from "./bulletin-message.vue?vue&type=script&lang=js"
export * from "./bulletin-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__